export enum CompletionPurposeEnum {
    STORY_PITCH = 'STORY_PITCH',
    NEWS_ANNOUNCEMENT = 'NEWS_ANNOUNCEMENT',
    PRODUCT_LAUNCH_ANNOUNCEMENT = 'PRODUCT_LAUNCH_ANNOUNCEMENT',
    MILESTONE_ANNOUNCEMENT = 'MILESTONE_ANNOUNCEMENT',
    ACHIEVEMENT_ANNOUNCEMENT = 'ACHIEVEMENT_ANNOUNCEMENT',
    PARTNERSHIP_ANNOUNCEMENT = 'PARTNERSHIP_ANNOUNCEMENT',
    PROMOTION_HIRING_ANNOUNCEMENT = 'PROMOTION_HIRING_ANNOUNCEMENT',
    EVENT_ANNOUNCEMENT = 'EVENT_ANNOUNCEMENT',
    EVENT_INVITATION = 'EVENT_INVITATION',
    MEDIA_ALERT = 'MEDIA_ALERT',
    NEWS_LETTER = 'NEWS_LETTER',
    SHARE_THOUGHT_LEADERSHIP = 'SHARE_THOUGHT_LEADERSHIP',
    SHARE_EDUCATIONAL_CONTENT = 'SHARE_EDUCATIONAL_CONTENT',
    MEDIA_KIT_DISTRIBUTION = 'MEDIA_KIT_DISTRIBUTION',
    SURVEY_REQUEST = 'SURVEY_REQUEST',
    FEEDBACK_REQUEST = 'FEEDBACK_REQUEST',
    ANNUAL_REVIEW = 'ANNUAL_REVIEW',
    CUSTOM = 'CUSTOM'
};
